import { render, staticRenderFns } from "./f-image-upload.vue?vue&type=template&id=6a1edefa&scoped=true&"
import script from "./f-image-upload.vue?vue&type=script&lang=js&"
export * from "./f-image-upload.vue?vue&type=script&lang=js&"
import style0 from "./f-image-upload.vue?vue&type=style&index=0&id=6a1edefa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1edefa",
  null
  
)

export default component.exports